/* eslint-disable jsx-a11y/anchor-has-content, no-script-url */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal-es';
// import { Document, Page } from 'react-pdf';

import {
  isPrivacyPolicy,
  acceptPrivacyPolicy
} from './utils'

// import { connectModal, openModal, closeModal } from './components/modal'

// @connectModal
class App extends Component {
  static propTypes = {
    content: PropTypes.shape(),
    defaultLanguage: PropTypes.string,
    language: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string
    })),
    description: PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string
    }),
    modalButton: PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string
    }),
    acceptButton: PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string
    }),
  }

  static defaultProps = {
    content: {},
    defaultLanguage: '',
    language: [],
    description: {},
    modalButton: {},
    acceptButton: {}
  }

  state = {
    isActive: isPrivacyPolicy(),
    numPages: 1,
    width: 600,
    currentlanguage: this.props.defaultLanguage
  }

  // updateDimensions = () => {
  //   const currentWidth = this.state.width;
  //   let width = 600;
  //   const innerWidth = window.innerWidth;
  //   if (innerWidth) {
  //     if (innerWidth <= 768) width = 400;
  //     if (innerWidth <= 520) width = 300;
  //   }
  //   if (currentWidth !== width) this.setState(() => ({ width: width }))
  // }


  // componentDidMount() {
  //   this.updateDimensions();
  //   window.addEventListener('resize', this.updateDimensions);
  // }

  // componentWillUnmount() {
  //   window.removeEventListener('resize', this.updateDimensions);
  // }

  getContentWithLanguage = (content) => {
    const { currentlanguage } = this.state;
    return content[currentlanguage] ? content[currentlanguage] : '';
  }

  // onDocumentLoadSuccess = ({ numPages }) => {
  //   this.setState({ numPages });
  // }

  handleAcceptPrivacyPolicy = () => {
    acceptPrivacyPolicy();
    this.setState(() => ({ isActive: true }))
  }

  handleSwicthLanguage = (key) => {
    this.setState(() => ({
      currentlanguage: key
    }))
  }

  render() {
    const { isActive, numPages, width, currentlanguage } = this.state;
    const {
      content,
      language,
      description,
      modalButton,
      acceptButton,
    } = this.props;
    if (isActive) return '';
    // const pagePDF = [];
    // for (let i = 1; i <= numPages; i++) {
    //   pagePDF.push(<Page key={i} width={width} pageNumber={i} />)
    // }
    return (
      <div className={`privacy-policy ${currentlanguage}`}>
        <div className="content">
          <ul className="language">
            {language.map((obj) => {
              return (
                <li key={obj.value}>
                  <a
                    href="Javascript:;"
                    className={currentlanguage === obj.value ? 'active' : ''}
                    onClick={() => this.handleSwicthLanguage(obj.value)}
                  >{obj.label}</a>
                </li>
              )
            })}
          </ul>
          <div className="description">
            <div>
              <span>{this.getContentWithLanguage(description)}</span>
              <a href={this.getContentWithLanguage(content)} className="button-popup">
                {this.getContentWithLanguage(modalButton)}
              </a>
            </div>
          </div>
          <button className="button-accept" onClick={this.handleAcceptPrivacyPolicy}>
            {this.getContentWithLanguage(acceptButton)}
          </button>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js